module.exports = __webpack_public_path__ + "static/media/home_24.df021065.svg";